export default {"src":"https://cloudflare.edhrec.com/_next/static/media/managw.ebff5281.svg","height":600,"width":600,"blurWidth":0,"blurHeight":0};